export default {
  contact: null,
  contacts: null,
  newContacts: null,
  documentTypes: ["DNI", "Carnet de extranjería", "RUC", "Pasaporte"],
};
